import type { Lesson } from "../types";

/**
 * Los diagnosticos se conservan en el paquete curricular para que el area
 * administrativa pueda usarlos, pero nunca forman parte del recorrido normal
 * del estudiante.
 *
 * Los sufijos mantienen compatibilidad con paquetes publicados antes de que
 * existiera el campo `placement`.
 */
export function isDiagnosticLesson(lesson: Lesson): boolean {
  return lesson.placement === "diagnostics"
    || lesson.id.toLowerCase().endsWith("-diagnostic")
    || lesson.unitId?.toLowerCase().endsWith("-diagnostic") === true;
}

export function courseLessons(lessons: Lesson[]): Lesson[] {
  return lessons.filter((lesson) => !isDiagnosticLesson(lesson));
}
